import { z } from 'zod';

export const essayEvolutionSeriesSchema = z.object({
  nome: z.string(),
  pontuacoes: z.array(z.number()),
});

export type EssayEvolutionSeries = z.infer<typeof essayEvolutionSeriesSchema>;

export const essayEvolutionResponseSchema = z.object({
  metaEscola: z.number().nullish(),
  series: z.array(essayEvolutionSeriesSchema),
  interpretacao: z.string().nullish(),
});

export type EssayEvolutionResponse = z.infer<typeof essayEvolutionResponseSchema>;
